import { vnTemplate } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate';
import { listPagePagination_template as pagination_template } from '~/components/templates/listPagePagination_template';
import { resultsInfo_template } from '../../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template';
import { renderRecruitingQuestionsTable } from '~/components/recruiting/recruiting-questions-table';
import { html, LpButton, LpPageHeader } from '~/design-system';
export class adminRecruitingQuestions_template extends vnTemplate {
    /**
     * Return the template key used by the Valnet template framework.
     *
     * @return string
     */
    getTemplateName() {
        return 'adminRecruitingQuestions-template';
    }
    /**
     * Return the CSS classes applied to the template root element.
     *
     * @return Array<string>
     */
    getMainElementClasses() {
        return ['questions-page'];
    }
    /**
     * Initialize nested template partials used by this template.
     *
     * @return void
     */
    initPartial() {
        this.pagination = new pagination_template('adminRecruitingQuestionsPagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 20;
        this.resultsInfo = new resultsInfo_template('adminRecruitingQuestionsResultInfo', this.getTemplateViewModel(), this.caller);
    }
    /**
     * Build the Knockout view model used by this template.
     *
     * @return any
     */
    buildViewModel() {
        const self = this;
        return {
            questions: ko.observableArray([]),
            onClickBack: function () { self.caller.backToQuestionBanks(); },
            onClickCreate: function () { self.caller.createQuestion(); },
            onClickEdit: function (row) { self.caller.editQuestion(row.id); },
        };
    }
    /**
     * Return the HTML markup for this template.
     *
     * @return string
     */
    getTemplateHtml() {
        return `
            <div class="w-content questions-page__content">
            ${LpPageHeader({
            title: 'Available Questions',
            description: 'Manage available recruiting questions.',
            icon: 'question',
            actions: html `
                    ${LpButton({
                label: 'Question Banks',
                prefixIcon: 'arrow-left',
                size: 'base',
                variant: 'secondary',
                attributes: {
                    'data-bind': 'click: onClickBack',
                },
            })}
                    ${LpButton({
                label: 'Create Question',
                prefixIcon: 'plus',
                size: 'base',
                variant: 'primary',
                attributes: {
                    'data-bind': 'click: onClickCreate',
                },
            })}
                `,
        })}

            <div class="list-page-module questions-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${renderRecruitingQuestionsTable()}
                </div>
                <div class="data-module__footer list-page-module__footer">
                    <div class="list-page-module__toolbar">
                        <div class="list-page-module__meta">
                            ${this.resultsInfo.getHtmlBuild()}
                        </div>
                        <div class="list-page-module__pagination">
                            ${this.pagination.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>
            </div>
        `;
    }
    /**
     * Build the request payload from the current view model state.
     *
     * @return object
     */
    getViewModelForRequest() {
        return {
            pagination: this.getPaginationViewModel(),
        };
    }
    /**
     * Return the pagination partial view model.
     *
     * @return any
     */
    getPaginationViewModel() {
        return this.pagination ? this.pagination.getTemplateViewModel() : null;
    }
    /**
     * Apply question rows returned by the API to the view model.
     *
     * @param questions Array<any>
     * @return void
     */
    setQuestions(questions) {
        this.getTemplateViewModel().questions(questions || []);
    }
    /**
     * Update the pagination partial with the result count.
     *
     * @param totalCount any
     * @return void
     */
    updatePagination(totalCount) {
        if (this.pagination) {
            this.pagination.setNumberItemToPaginate(totalCount);
        }
    }
    /**
     * Update the result-info partial with list metadata.
     *
     * @param totalResults number
     * @param totalPages number
     * @param execTime number
     * @return void
     */
    setResultInfo(totalResults, totalPages, execTime) {
        this.resultsInfo.setNbResults(totalResults);
        this.resultsInfo.setNbPages(totalPages);
        this.resultsInfo.setExecutionTime(execTime);
    }
    /**
     * Set view model from request on the view model.
     *
     * @param params Array<any>
     * @return void
     */
    setViewModelFromRequest(params) {
        const paginationVm = this.getPaginationViewModel();
        if (typeof params['pagination'] !== 'undefined' && params['pagination'] && paginationVm && typeof paginationVm.pageNumber === 'function') {
            paginationVm.pageNumber(Math.max(1, Number(params['pagination'].pageNumber || 1)));
        }
    }
}
